module.exports = __webpack_public_path__ + "media/application/images/svgs/camera-off-525041e34001f5a276ba4531a23b4b24.svg";